export default function() {
  return `temp-${Math.floor(Math.random() * 100000000000)}`
}